/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Singular resource nested under a conversation:
// GET /api/v1/accounts/:account_id/conversations/:conversation_id/visit_scheduling_link
// Built server-side (see VisitScheduling::LinkBuilder) so the dashboard never has to know
// the rules the public scheduling page enforces.
class VisitSchedulingLinksAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/visit_scheduling_link`);
  }
}

export default new VisitSchedulingLinksAPI();
